export default "__VITE_ASSET__DgMQlrGr__"